<template>
    <div class="emarticon-card">
<!--      <div class="emarticon-card-box">-->
        <div :class="`${classname === 'home-slide' ? classname : 'emarticon-card-box'}`">
<!--        <div v-if="slideData.length === 0" class="blank-box">-->
<!--          <div class="card-text-wrap">-->
<!--            <em>등록된 이마티콘이 없습니다.</em>-->
<!--          </div>-->
<!--        </div>-->
        <swiper v-if="slideData.length === 0" :options="swiperOptions">
          <swiper-slide class="emarticon-mainimg">
            <div class="image-area">
              <a href="javascript:void(0);">
                <img src="@/assets/images/cards/emarticon_card_blank.png" alt="e마티콘 등록된 이마티콘이 없습니다" />
                <span class="save-item-text"></span>
              </a>
            </div>
            <div class="emarticon-card-text-box">
              <span class="emarticon-card-subject1">이마티콘 구매시 여기에 등록됩니다</span>
            </div>
          </swiper-slide>
        </swiper>
        <swiper v-else ref="cardSlider" :options="type === 'select' ? selectSwiperOptions : swiperOptions">
            <swiper-slide v-for="(item, index) in slideData" :key="index" class="emarticon-mainimg">
                <div class="image-area">
                  <a href="javascript:void(0);" @click="toggleBarcodePopup(item)">
                    <img :class="item.status !== 'ACTIVATION'? 'image-filter': null" :src="item.thumbnailImageUrl" :alt="item.thumbnailImageDesc" />
                    <span class="save-item-text" v-if="item.status === 'EXPIRATION'">만료</span>
                    <span class="save-item-text" v-else-if="item.status === 'LOCKED' && (item.refundStatus === null || item.refundStatus === '')">사용중지</span>
                    <span class="save-item-text" v-else-if="item.status === 'LOCKED' && item.refundStatus !== null && item.refundStatus === 'REQUEST'">환불요청</span>
                    <span class="save-item-text" v-else-if="item.status === 'LOCKED' && item.refundStatus !== null && item.refundStatus === 'PROCESSING'">환불진행중</span>
                  </a>
                </div>
                <div class="emarticon-card-text-box">
<!--                <div :class="`${classname === 'home-slide' ? '' : 'emarticon-card-text-box'}`">-->
                  <span class="emarticon-card-subject1">{{ item.prepaidCardNickName != null? item.prepaidCardNickName : item.giftMessage != null? item.giftMessage : '' }}</span>
                  <span class="emarticon-card-price1">{{ Number(item.remainCash).toLocaleString() }}</span>
<!--                  <button v-if="type !== 'select'" class="icon-barcode-black absolute-barcode" title="바코드 화면보기" @click="toggleBarcodePopup(item)"></button>-->
                </div>
                <button v-if="type !== 'select'" class="icon-barcode-black absolute-barcode" title="바코드 화면보기" @click="toggleBarcodePopup(item)"></button>
            </swiper-slide>
        </swiper>
      </div>
    </div>
</template>

<script>
import CardText from'@/components/common/CardText.vue';
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: 'EmarticonCard',
  components: { CardText, Swiper, SwiperSlide },
  props: ['slideData', 'type', 'classname'],
  data() {
    const self = this;
    return {
      cardActive: 0,
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 40,
        centeredSlides: true,
        // loop: true
      },
      selectSwiperOptions: {
        slidesPerView: 1,
        spaceBetween: 20,
        // loop: true,
        on: {
          slideChange: function() {
            self._data.cardActive = this.realIndex;
            self.$refs.slidePagenation.scrollLeft = (self.$refs.slidePagenation.querySelector('li').offsetWidth) * this.realIndex;
          }
        }
      }
    }
  },
  methods: {
    slideIndicatorHandler(e, i) {
      this.$refs.cardSlider.$swiper.slideTo(i);
    },
    toggleBarcodePopup(barcodeInfo) {
      if(barcodeInfo.status === 'ACTIVATION') {
        barcodeInfo.showBottons = true;
        this.$emit('toggleBarcodePopup', barcodeInfo)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/common/emarticonCard.scss';

  .home-slide {
    position: relative;
    width: 100%; height: 100%;
    height: rem(200.98);
    // border-radius: rem(15);
    em {
      height: 100%;
      @include flex-center;
      @include font-size(rem(12), rem(20), 500);
      font-style: normal;
      color: $color-gray-700;
    }
    .image-area {
      width: 100%; height: 100%;
      max-height: rem(157);
      position: relative;
      border-radius: rem(15);
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    > div {
      height: 100%;
    }
    .emarticon-card-text-box {
      position: relative;
      display: inline-block;
      bottom: 0;
      left: 0;
      z-index: 9999;
      @include flex-center;
      height: rem(28);
      margin-top: rem(16);
      .emarticon-card-subject1 {
        @include font-noto-sans;
        @include font-size(rem(12), rem(20), 500);
        letter-spacing: -0.6px;
        color: $color-black-400;
      }
      .emarticon-card-price1 {
        padding-left: rem(12);
        @include font-roboto;
        @include font-size(rem(22), rem(28), 700);
        color: $color-black-400;
        &::after {
          content: '원';
          display: inline-block;
          @include font-noto-sans;
          @include font-size(rem(16), rem(21), 500);
        }
      }
    }
    .blank-box {
      .card-text-wrap {
        width: rem(240);
        height: rem(157);
        border: 1.5px dashed $color-gray-500;
        background: #f8f8f8;
        margin: 0 auto;
        border-radius: rem(15);
      }
    }
    .swiper-slide { width: rem(240); aspect-ratio: 240 / 157; }
  }
</style>